<template>
  <v-ad-page title="优惠券说明">
    <div v-for="(item, index) in list" :key="index" class="ad-coupon-info">
      <div class="ad-coupon-info__title">{{ item.title }}</div>
      <p class="ad-coupon-info__text">{{ item.text }}</p>
    </div>
  </v-ad-page>
</template>

<script>
import VAdPage from '@/components/AdPage'

export default {
  components: { VAdPage },
  data() {
    return {
      list: [
        {
          title: '1.优惠券怎么得到？',
          text:
            '药店可以通过收银一体机副屏的广告播放来获取收益，收益在广告投放周期结束的第二天发放到智慧脸账户内，账户余额累计到300（个），可兑换一张面额为300的优惠券。'
        },
        {
          title: '2.优惠券可以在什么地方使用？',
          text:
            '优惠券可以在“药帮忙”平台采购药品以及其他商品时使用。使用之前需要绑定“药帮忙”账号，没有账号？'
        },
        {
          title: '3.优惠券使用有什么限制？',
          text: '优惠券在“药帮忙”平台无门槛使用。优惠券有效期为一个月。'
        },
        {
          title: '4.优惠券面额是多少？',
          text: '目前优惠券只有“￥300.00”这一种。'
        }
      ]
    }
  },
  computed: {},

  async created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.ad-coupon-info {
  // margin: 10px 0;
  margin-bottom: 10px;
  padding: 13px 15px 12px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;

  .ad-coupon-info__title {
    font-size: 13px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
  }

  .ad-coupon-info__text {
    margin: 7px 0 0;
    padding: 0;
    font-size: 12px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 22px;
  }
}
</style>
